import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainerBase from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper } from 'remote-com-shared/components/SectionWrapper';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import styled, { css } from 'styled-components';

import { DescriptionComponent, TitleComponent } from '../sharedStyles';

import {
  mobileBreakpoint,
  fromTabletBreakpoint,
  tabletBreakpoint,
} from '@/src/domains/shared/breakpoints';

const ImageAndDescriptionWrapper = styled(SectionWrapper)`
  background-color: var(--color-tone-primary);

  ${TitleComponent} {
    color: var(--colors-blank);
    text-align: left;
    font-size: 40px;
  }

  ${DescriptionComponent} {
    color: var(--colors-blank);
    text-align: left;
    font-size: 18px;

    ${mobileBreakpoint(css`
      img {
        max-width: 80%;
      }
    `)};
  }

  ${fromTabletBreakpoint(css`
    padding-top: 200px;
    clip-path: ellipse(120% 100% at 50% 100%);
  `)}
`;

const ContentContainer = styled(ContentContainerBase)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;

  ${tabletBreakpoint(css`
    display: flex;
    flex-direction: column-reverse;
  `)};
`;

const ImageWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export function ImageAndDescriptionSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, image } = primary;
  return (
    <ImageAndDescriptionWrapper>
      <ContentContainer>
        <ImageWrapper>
          {image && <Image src={image.url} {...image.dimensions} alt={image.alt || ''} />}
        </ImageWrapper>
        <div>
          {fieldHasContent(title) && (
            <TitleComponent>
              <PrismicRichText field={title} />
            </TitleComponent>
          )}
          {fieldHasContent(description) && (
            <DescriptionComponent>
              <PrismicRichText field={description} />
            </DescriptionComponent>
          )}
        </div>
      </ContentContainer>
    </ImageAndDescriptionWrapper>
  );
}
